import bullsBearsBeginnersImg from 'assets/images/bullsBearsBeginners.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const bullsBearsBeginners = {
  book: {
    id: 'bulls-bears-beginners',
    format: FLIP_BOOKS,
    title: 'Bulls, Bears & Beginners',
    subtitle: 'Equities and the Stock Market',
    videos: 'Erwin W. Heri, Nicolas Plain',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 38, videos: 35 },
    price: [32, 39],
    introductions: ['A fresh and engaging way to learn the essentials of the stock market'],
    image: bullsBearsBeginnersImg,
    overviewImg: bullsBearsBeginnersImg,
  },
  bookIds: [44, 45],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([32, 39], [45, 44]),
};

export default bullsBearsBeginners;
